<template>
    <div class="my-4 ma-md-5 mx-lg-12">
    <v-row
      no-gutters
      v-bind:class="[
        'mx-2 align-center',
        {
          'flex-column justify-center': !$vuetify.breakpoint.mdAndUp,
        },
      ]"
    >
    </v-row>
    <template>
      <v-row class="titleMobile"
      :style="{gap: '1rem', marginLeft: '1rem !important'}">
        <v-btn
          class="back"
          dark
          icon
          to="/utils"
        >
          <v-icon
          :style="{color: '#27846d !important', fontSize: '34px'}"
          >
            icon-ayudadigital-volver
          </v-icon>
        </v-btn>
        <h2> {{ $t('views.utils.acortador.title') }} </h2>
      </v-row>
        <v-container class="mt-3 shortener-container" fluid>
          <v-row>
            <p> {{ $t('views.utils.acortador.description') }} </p>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" sm="6" md="6" class="text-center textMobile">
              <v-textarea
                id="paste-input"
                v-model="inputUrl"
                class="mb-2 !important"
                label="Pega o escribe la URL..."
                placeholder="Pega o escribe la URL..."
                auto-grow
                outlined
                rows="2"
                :disabled="loading"
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="6" class="text-center btnMobile">
              <v-btn
                class="shortener-btn"
                @click="shortenUrl"
                color="primary"
                block
                >
                Acortar
                </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="shortenedUrl != ''" justify="center">
            <v-col cols="12" sm="6" md="6" class="text-center textMobile">
              <v-textarea
                  v-model="shortenedUrl"
                  class="mb-2 !important"
                  label="Url acortada"
                  auto-grow
                  outlined
                  rows="1"
                  readonly
                  hide-details
              />
            </v-col>
            <v-col cols="12" sm="6" md="6" class="text-center btnMobile">
              <div class="ki-actions btnGroupShare col-auto px-0 pt-0 pb-0"
                :style="{ borderColor: 'rgb(39, 132, 109)'  }">
                <v-btn
                  class="v-btn v-btn--icon v-btn--round
                  theme--light v-size--default iconHover"
                  color="primary--text blue-grey lighten-4 donwload"
                  dark
                  icon
                  @click.prevent="$event => share($event)"
                >
                  <v-icon
                    :style="{color:'#757575'}"
                  >
                    mdi-share-variant
                  </v-icon>
                </v-btn>
                <v-spacer class="spacer"></v-spacer>
                <v-btn
                  class="v-btn v-btn--icon v-btn--round
                  theme--light v-size--default iconHover"
                  color="primary--text blue-grey lighten-4"
                  dark
                  icon
                  @click="copyShortenedUrl"
                  >
                  <v-icon
                    :style="{color:'#757575'}"
                  >
                    mdi-content-copy
                  </v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="shortenedUrl != '' && showBtnRetry">
            <v-col cols="12" sm="6" md="6"  class="text-center btnClear">
              <v-btn
                @click="clear"
                plain
                >
                <v-icon left>mdi-refresh</v-icon>
                Acortar otra URL
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <ShareDialog
        :visible="openDialog"
        @input="openDialog = false"
        :item="sharedItem || {}"
        :positionX="sharedDialogPosition.positionX"
        :positionY="sharedDialogPosition.positionY"
      ></ShareDialog>
  </div>
</template>

<script>

import { ShareDialog } from '@/components';

export default {
  components: { ShareDialog },
  data() {
    return {
      inputUrl: '',
      shortenedUrl: '',
      loading: false,
      openDialog: false,
      sharedItem: null,
      sharedDialogPosition: {},
      showBtnRetry: false,
    };
  },
  methods: {
    debug(e, i) {
      console.log(e, i);
    },
    async shortenUrl() {
      this.showBtnRetry = true;
      // Simulación de acortado
      if (
        this.inputUrl.includes('junta-andalucia')
        || this.inputUrl.includes('juntadeandalucia')
      ) {
        const { id, userid } = this.$store.getters['session/user'];

        const data = {
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
          },
          url: this.inputUrl,
        };

        const result = await this.$api.getClient('gestorNotificacion').shareMobileMessage(data);
        this.shortenedUrl = result.data.urlCorta;
      } else {
        this.shortenedUrl = 'Solo se pueden acortar URLs de la Junta de Andalucía';
      }
    },
    clear() {
      this.inputUrl = '';
      this.shortenedUrl = '';
      this.showBtnRetry = false;
    },
    async copyShortenedUrl() {
      if (this.shortenedUrl) {
        await navigator.clipboard.writeText(this.shortenedUrl);

        this.$store.dispatch('messages/createNotificationMessage', {
          type: 'success',
          icon: 'mdi-check-circle',
          title: this.$t('views.utils.acortador.urlCopiada'),
          timeout: this.$getConst('notifications.timeout'),
        });
      }
    },
    share(evt) {
      console.log('evt', evt);
      evt.preventDefault();
      const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;
      if (isMobile === true && window.flutter_inappwebview) {
        const args = {
          url: this.shortenedUrl,
          urlCorta: this.shortenedUrl,
          formName: '',
        };
        window.flutter_inappwebview.callHandler('shareDataUsingNative', args);
      } else {
        console.log('Compartir en web', { a: this.shortenedUrl });
        this.openDialog = true;
        this.sharedItem = {
          url: this.shortenedUrl,
          urlCorta: this.shortenedUrl,
          formName: '',
        };

        const closestButton = evt.target.closest('button');
        const boundingRect = closestButton.getBoundingClientRect();

        this.sharedDialogPosition = {
          positionX: boundingRect.left + (closestButton.offsetWidth / 2),
          positionY: boundingRect.top + (closestButton.offsetHeight / 2),
        };
      }
    },
    // async pegar() {
    //   try {
    //     const text = await navigator.clipboard.readText();
    //     this.inputUrl = text;
    //     this.shortenUrl();
    //   } catch (err) {
    //     console.error('Error leyendo portapapeles:', err);
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.shortener-container {
  width: 100%;
  background: #fff;
  padding: 2rem !important;
  min-width: 100% !important;
}
.shortener-btn {
  color: #fff !important;
  font-weight: 600;
  box-shadow: none;
  margin-top: 16px !important;
  /*background: linear-gradient(90deg, #1abc9c 0%, #43e97b 100%);
  margin-bottom: 2rem !important;
  background: linear-gradient(45deg, #01968B, #0D9B83, #2DA76E, #62BC4C, #A3D521);
  border-radius: 50px;
  */
}
.shortener-btn .v-icon {
  color: #fff !important;
}
.v-btn--block{
    min-width: 135px !important;
    max-width: 135px !important;
}
.v-text-field__details{
  display: none !important;
}
.textMobile{
  /*border-radius: 10px !important;*/
}
.btnGroupShare{
  display: flex;
  padding-top: 12px !important
  /*
  justify-content: end;
  min-width: 135px !important;
  max-width: 135px !important;
  */
}
.btnCircle{
  border-color: rgb(39, 132, 109);
  height: 85px !important;
}
.spacer{
  width: 1rem !important;
  max-width: 1rem !important;
}
.ki-actions {
  position: relative;
  /*padding-top: 18px !important;*/

  > button {
    width: 42px !important;
    height: 42px !important;
    border-radius: 50%;
    border-color: inherit;
    border-width: 2px;
    border-style: solid;
    background-color: white;

    &:last-child .ki-action-name.right {
      left: 100%;
      display: table;
      transform: translateX(-100%);
    }
  }

  .ki-action-name {
    pointer-events: none;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}
@media screen and (max-width: 600px) {
    .v-btn--block{
        margin-top: 0px !important;
        min-width: 100% !important;
        max-width: 100% !important;
    }
    .btnMobile{
      /*padding-top: 0px !important;*/
    }
    .textMobile{
      padding-bottom: 0px !important;
    }
    .btnClear{
      padding-top: 0px !important;
    }
    .btnGroupShare{
      justify-content: center;
    }
}
</style>
